export default "__VITE_ASSET__Bch1PG56__"